import sortBy from 'lodash/sortBy';

export const RESULTS_LIMIT = 100;

// Ranked best first, so sortBy on match_rank puts prefix hits above the rest.
export const MATCH_PREFIX = 0;
export const MATCH_CONTAINS = 1;
export const MATCH_COLLAPSED = 2;

const collapse = value => String(value || '').replace(/\s+/g, '');

export function orgSortKey(org) {
    return String((org && org.display_name) || '')
        .trim()
        .toLowerCase();
}

export function sortOrgs(orgs) {
    return sortBy(orgs || [], [orgSortKey]);
}

export function matchOrganizations(orgs, searchString) {
    const term = String(searchString || '')
        .trim()
        .toLowerCase();
    if (!term) {
        return [];
    }
    const collapsedTerm = collapse(term);
    const matches = [];
    (orgs || []).forEach(org => {
        const name = orgSortKey(org);
        const index = name.indexOf(term);
        if (index === 0) {
            matches.push({ org, match_rank: MATCH_PREFIX, match_index: 0 });
            return;
        }
        if (index > 0) {
            matches.push({ org, match_rank: MATCH_CONTAINS, match_index: index });
            return;
        }
        const collapsedIndex = collapse(name).indexOf(collapsedTerm);
        if (collapsedIndex >= 0) {
            matches.push({ org, match_rank: MATCH_COLLAPSED, match_index: collapsedIndex });
        }
    });
    return sortBy(matches, ['match_rank', 'match_index', option => orgSortKey(option.org)]);
}

export function computeVisibleOrgs({ allOrgs, searchString, limit = RESULTS_LIMIT }) {
    const searching = Boolean(String(searchString || '').trim());
    const matched = searching ? matchOrganizations(allOrgs, searchString).map(option => option.org) : sortOrgs(allOrgs);
    return {
        options: matched.slice(0, limit),
        total: matched.length,
        allTotal: (allOrgs || []).length,
        searching,
    };
}

export function isCurrentOrg(org) {
    return Boolean(org && org.active);
}
